<template>
<div class="chapter">
<div class="inner_page">
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="para"> </p>
<p class="para">Our imprisonment during World War II has been documented by those rare filmmakers, authors, and skilled artists and poets whom those of us within this community have all come to know and love. Our project, now this book, provides a vehicle for the common folk to offer personal insights and to record their individual histories during and after that catastrophic mistake in American history that most of us are reluctant to discuss or fully acknowledge today. Our recollections give each story a face and a voice and add to our Asian American legacy.</p>
<p class="indent-para">Surviving the injustice, the prejudice, and the hardships during resettlement speaks volumes about the spirit that has led us to stand tall, to embrace our contributions that have made our country what it is today. Most of us, however, have remained silent, and now over half of us are not here to reveal our secrets of bouncing back from nothingness.</p>
<p class="indent-para1">The following stories can inspire those who sit in waiting to tell their version of history and can aid them in the healing process. Our story is an American story, a portrait of others’ mistakes, and our struggles to endure and overcome.</p>
<p class="right-para"><em>—Toru Saito<br/>Public comment before the California State Library’s California Civil Liberties Public Education Program in 2007</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?d49073d8